import * as R from 'ramda';
import {
  useState,
  useEffect,
  useCallback,
} from 'react';
//////////////////////////////////////////////////

const initialSize = {
  width: 0,
  height: 0,
};

const useElementSize = () => {
  const [element, setElement] = useState(null);
  const [size, setSize] = useState(initialSize);
  const elementRef = useCallback((nextElement) => setElement(nextElement), []);

  useEffect(() => {
    if (!element) return undefined;

    const updateSize = () => {
      const nextSize = {
        width: element.clientWidth,
        height: element.clientHeight,
      };

      setSize((currentSize) => (
        R.and(
          R.equals(currentSize.width, nextSize.width),
          R.equals(currentSize.height, nextSize.height),
        )
          ? currentSize
          : nextSize
      ));
    };

    const resizeObserver = new window.ResizeObserver(updateSize);

    updateSize();
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [element]);

  return [elementRef, size];
};

export default useElementSize;
